export default __webpack_public_path__ + "static/media/BootsSharp-Bold.fec6cee7.woff2";